<template>
  <div class="promo-shell">
    <FissionForm />
    <FissionGallery />
  </div>

  <div v-if="workbench.lightbox.show" class="lightbox" @click="workbench.closeLightbox">
    <img :src="workbench.lightbox.url" alt="preview" @click.stop />
    <button class="lightbox-close" @click.stop="workbench.closeLightbox">×</button>
  </div>
</template>

<script setup>
import FissionForm from '@/components/fission/FissionForm.vue'
import FissionGallery from '@/components/fission/FissionGallery.vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'

const workbench = useWorkbenchStore()
</script>
